import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { STATUS, STATUS_LOADING, STATUS_ERROR } from '@rexlabs/entity-normalizer';
import { generateActionCreators } from '../utils/connectors';
import { mapDispatch } from './default';
import _ from 'lodash';
import { getDisplayName } from '../utils/react';
/**
 * Maps value list from redux to props
 * @param  {Object} model
 * @param  {Object} state
 * @param  {Object} props
 * @return {Function}
 */

export function mapValueListState(model, state, props) {
  return model.selectors(state, props);
}
/**
 * Maps action creators as redux dispatch functions to props
 * @param  {Object} model
 * @param  {Function} dispatch
 * @return {Function}
 */

export function mapValueListDispatch(model, dispatch) {
  return generateActionCreators(model)(dispatch);
}
/**
 * HoC, that wraps React component and loads given value lists
 * either from store or from the API
 * @param  {...Object} models
 * @return {Function}
 */

export function withValueLists() {
  for (var _len = arguments.length, models = new Array(_len), _key = 0; _key < _len; _key++) {
    models[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var WithValueLists = /*#__PURE__*/function (_Component) {
      _inherits(WithValueLists, _Component);

      var _super = _createSuper(WithValueLists);

      function WithValueLists() {
        _classCallCheck(this, WithValueLists);

        return _super.apply(this, arguments);
      }

      _createClass(WithValueLists, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this = this;

          _forEachInstanceProperty(models).call(models, function (model) {
            var name = model.modelName;
            var list = _this.props.__state[name];

            if (list && (!list.status || list.status === STATUS_ERROR)) {
              // Fetch value list if not already in store
              _this.props.__actions[name].fetch();
            }
          });
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          // Custom shallow equal
          for (var key in nextProps) {
            var _context;

            if (!_includesInstanceProperty(_context = ['__state', '__actions']).call(_context, key) && this.props[key] !== nextProps[key]) {
              return true;
            }
          }

          for (var valueListKey in nextProps.__state) {
            var _context2, _context3;

            if (_.get(nextProps, _concatInstanceProperty(_context2 = "__state.".concat(valueListKey, ".")).call(_context2, STATUS)) !== _.get(this.props, _concatInstanceProperty(_context3 = "__state.".concat(valueListKey, ".")).call(_context3, STATUS))) {
              return true;
            }
          }

          return false;
        }
      }, {
        key: "prepProps",
        value: function prepProps() {
          var _this2 = this;

          var keys = _Object$keys(this.props.__state);

          var valueLists = {}; // Set default status of all lists to `loading`

          _forEachInstanceProperty(keys).call(keys, function (key) {
            var _objectSpread2;

            var valueListState = _this2.props.__state[key] || {};
            var valueListActions = _this2.props.__actions[key] || {};
            valueLists[key] = _objectSpread(_objectSpread(_objectSpread({}, valueListState), valueListActions), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, STATUS, valueListState[STATUS] || STATUS_LOADING), _defineProperty(_objectSpread2, "realStatus", valueListState[STATUS]), _objectSpread2));
          });

          return _objectSpread(_objectSpread({}, this.props), {}, {
            valueLists: valueLists
          });
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(WrappedComponent, this.prepProps());
        }
      }]);

      return WithValueLists;
    }(Component);

    _defineProperty(WithValueLists, "displayName", "withValueLists(".concat(getDisplayName(WrappedComponent), ")"));

    var mapStateToProps = function mapStateToProps(state) {
      var valueLists = {};

      _forEachInstanceProperty(models).call(models, function (model) {
        valueLists[model.modelName] = state.valueLists[model.modelName];
      });

      return {
        __state: valueLists
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      var valueLists = {};

      _forEachInstanceProperty(models).call(models, function (model) {
        valueLists[model.modelName] = mapDispatch(model, dispatch);
      });

      return {
        __actions: valueLists
      };
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithValueLists);
  };
}